module.exports = __webpack_public_path__ + "img/file.264d884f.svg";